import { render, staticRenderFns } from "./PopModifyBasic.vue?vue&type=template&id=518f8ef4"
import script from "./PopModifyBasic.vue?vue&type=script&lang=js"
export * from "./PopModifyBasic.vue?vue&type=script&lang=js"
import style0 from "./PopModifyBasic.vue?vue&type=style&index=0&id=518f8ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports